import { render, staticRenderFns } from "./FormControlUrlSlug.vue?vue&type=template&id=161bbca2"
import script from "./FormControlUrlSlug.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlUrlSlug.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports